export default __webpack_public_path__ + "css/supplierEmailPurchaseOrder.bundle.css";